import './Banner.css'

const Banner = () => {
    return (
      <div className="banner-container">
            <h1>Calzado Importado</h1>
            <p>Revisa nuestro catalogo online!</p>
      </div>
  );
}

export default Banner;